import { render, staticRenderFns } from "./couponBuyRecord.vue?vue&type=template&id=652b5ed0&scoped=true"
import script from "./couponBuyRecord.vue?vue&type=script&lang=js"
export * from "./couponBuyRecord.vue?vue&type=script&lang=js"
import style0 from "./couponBuyRecord.vue?vue&type=style&index=0&id=652b5ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b5ed0",
  null
  
)

export default component.exports